import React from 'react';
import { PersonProfileImageSmall, PersonProfileImageSmallInfoCard } from '../PersonProfileImageSmall';
import Bem from '../../../lib/bemUtils/bem';
import { ProfileImageSmall } from '../../../types/api/ImageType';
import IUrl from '../../../types/IUrl';
import { PersonalData } from '../../../_lib/components/PersonalData/PersonalData';

export type PersonInformationProps = PersonalData & {
  profileImageUrl?: ProfileImageSmall;
  infoCardUrl?: IUrl;
};
/**
 * PersonInforamation with profile image and list of definitions
 */
export function PersonInformation({
  deletedUser,
  emailLink,
  infoCardUrl,
  modifier,
  orgUnit,
  phoneLink,
  profileImageUrl,
  profileLink,
  profileName,
  roleNames,
  officeDenotation,
}: PersonInformationProps) {
  return (
    <div className={Bem('person-information', modifier)}>
      {profileImageUrl && (
        <div className="person-information__image-container">
          {infoCardUrl
            ? (
                <PersonProfileImageSmallInfoCard
                  personInfoCardUrl={infoCardUrl}
                  profileImageUrl={profileImageUrl}
                  profileName={profileName}
                />
              )
            : (
                <PersonProfileImageSmall profileImageUrl={profileImageUrl} profileName={profileName} />
              )}
        </div>
      )}
      <div className="person-information__list">
        <PersonalData
          modifier={modifier}
          deletedUser={deletedUser}
          emailLink={emailLink}
          orgUnit={orgUnit}
          phoneLink={phoneLink}
          profileLink={profileLink}
          profileName={profileName}
          roleNames={roleNames}
          officeDenotation={officeDenotation}
        />
      </div>
    </div>
  );
}
